import React, { useContext } from 'react'
import {ShoppingCart} from "phosphor-react";
import {Heart} from "phosphor-react";
import { useState } from 'react';
import {ShopContext} from "../../context/shop-context";
import { Link } from "react-router-dom";
import "../detail/detail.css"


function Product(props) {
// Destructuring specific properties from props.data
const { id, productName, productDetail, price, productImage } = props.data;

// Getting cart-related functions and state from context
const { addToCart, cartItems, addToFavorites, removeFromFavorites, isItemInFavorites } = useContext(ShopContext);

// Getting the count of this specific item in the cart
const cartItemCount = cartItems[id];

// Handler for adding to favorites
const handleAddToFavorites = () => {
  addToFavorites(id); // Add this item to favorites
};

// Handler for removing from favorites
const handleRemoveFromFavorites = () => {
  removeFromFavorites(id); // Remove this item from favorites
};


return (

<div className="card">

  <div className="card-header">
  {isItemInFavorites(id) ? (
    <button className="custom-button" onClick={handleRemoveFromFavorites} >
    <Heart size={32} color="#ff0000" />
    </button>
        
      ) : (
        <button  className="custom-button" onClick={handleAddToFavorites} >
     <Heart/>
    </button>
       
      )}
    
  </div>
  <div className='cards-details'>
    <div className="card-img">
      <img src={productImage} alt='product' />
    </div>

    <div className="card-info">
      <Link to={`/product/${id}`}> <p className="text-title">{productName}</p>
      </Link>
      <p className="text-body">{productDetail}</p>
    </div>
  </div>
  <div className="card-footer">

    <span className="price-title">${price}</span>

    <button className="CartBtn" onClick={()=> addToCart(id)}>
      <span className="IconContainer">
        <ShoppingCart className="cart" />
      </span>
      <p className="add-to-cart">Add to Cart</p>
    </button>

  </div>
</div>

)
}

export default Product